var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',_vm._l((_vm.entriesList),function(entry,i){return _c('v-col',{key:i,attrs:{"sm":"6","md":"4","cols":"12"}},[_c('entry-card',{attrs:{"entry":entry}})],1)}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }